import { createReducer, on } from '@ngrx/store';
import * as SquareAccountActions from './square-account.actions';
import { SquareAccount } from './square-account.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SquareAccountsState {
    squareAccounts: SquareAccount[];
    squareAccount: SquareAccount | null;
    merchant: any | null;
    locations: any[];
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialSquareAccountsState: SquareAccountsState = {
    squareAccounts: [],
    squareAccount: null,
    merchant: null,
    locations: [],
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

export const squareAccountsReducer = createReducer(
    initialSquareAccountsState,

    // On Load All
    on(SquareAccountActions.loadSquareAccounts, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareAccountActions.loadSquareAccountsSuccess, (state, { squareAccounts }) => ({
        ...state,
        isLoading: false,
        squareAccounts,
    })),
    on(SquareAccountActions.loadSquareAccountsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Load Single
    on(SquareAccountActions.loadSquareAccount, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareAccountActions.loadSquareAccountSuccess, (state, { squareAccount }) => ({
        ...state,
        isLoading: false,
        squareAccount,
    })),
    on(SquareAccountActions.loadSquareAccountFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Create
    on(SquareAccountActions.createSquareAccount, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareAccountActions.createSquareAccountSuccess, (state, { squareAccount }) => ({
        ...state,
        isLoading: false,
        squareAccounts: [...(state.squareAccounts || []), squareAccount],
    })),
    on(SquareAccountActions.createSquareAccountFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Update
    on(SquareAccountActions.updateSquareAccount, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareAccountActions.updateSquareAccountSuccess, (state, { squareAccount }) => ({
        ...state,
        isLoading: false,
        squareAccounts: state.squareAccounts.map((s) =>
            s.id === squareAccount.id ? squareAccount : s
        ),
    })),
    on(SquareAccountActions.updateSquareAccountFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Delete
    on(SquareAccountActions.deleteSquareAccount, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareAccountActions.deleteSquareAccountSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        squareAccounts: state.squareAccounts.filter((s) => s.id !== id),
    })),
    on(SquareAccountActions.deleteSquareAccountFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Get Merchant By Token
    on(SquareAccountActions.getMerchantByToken, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareAccountActions.getMerchantByTokenSuccess, (state, { merchant }) => ({
        ...state,
        isLoading: false,
        merchant,
    })),
    on(SquareAccountActions.getMerchantByTokenFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // On Get Locations By Token
    on(SquareAccountActions.getLocationsByToken, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SquareAccountActions.getLocationsByTokenSuccess, (state, { locations }) => ({
        ...state,
        isLoading: false,
        locations,
    })),
    on(SquareAccountActions.getLocationsByTokenFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    }))
);
